import { NgModule } from '@angular/core';
import { CheckboxComponent } from './checkbox.component';

const MODULES = [CheckboxComponent];
@NgModule({
  imports: [...MODULES],
  exports: [...MODULES]
})
export class CheckboxModule {}
